import AmexPlatinumNightsBenefits from './AmexPlatinumNightsBenefits';

export default AmexPlatinumNightsBenefits;
